import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'

export default {

  data: function () {
    return {
      matlabParameterList: [],
      fullMatlabParameterList: [],
      deviceParameterList: [],
      fullDeviceParameterList: [],
      leakbotId: '',
      matlabParameterName: {},
      matlabParameterValue: '',
      filterParameterName: '',
      filterParameterNameList: '',
      errorMessage: '',
      fields: {
        key: {
          label: 'Parameter Name',
          sortable: true
        },
        value: {
          label: 'value',
          sortable: false
        }
      }
    }
  },
  mounted () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      this.fetchMatlabParameterList()
    }
  },

  methods: {
    fetchMatlabParameterList () {
      let options = {}

      this.$store.dispatch(APIEvent.MATLAB_PARAMETER_LIST, options)
        .then(res => {
          let paramList = []

          for (let key in res.data.params) {
            let parameter = []
            parameter['parameter_name'] = key
            parameter['parameter_type'] = res.data.params[key].type
            parameter['min'] = res.data.params[key].min
            parameter['max'] = res.data.params[key].max
            parameter['default'] = res.data.params[key].default

            paramList.push(parameter)
          }

          paramList.sort(this.compare)

          this.matlabParameterList = paramList
          this.fullMatlabParameterList = paramList
        })
        .catch(function (err) {
          let msg = 'The list can not be refreshed. Please check and try again :: '
          msg += err.message
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },

    compare (a, b) {
      // Use toUpperCase() to ignore character casing
      const nameA = a.parameter_name.toUpperCase()
      const nameB = b.parameter_name.toUpperCase()

      let comparison = 0
      if (nameA > nameB) {
        comparison = 1
      } else if (nameA < nameB) {
        comparison = -1
      }
      return comparison
    },

    leakbotIdChange () {
      let options = {
        leakbot_id: this.leakbotId
      }

      this.deviceParameterList = []
      this.fullDeviceParameterList = []
      this.matlabParameterValue = ''

      this.$store.dispatch(APIEvent.MATLAB_DEVICE_PARAMETERS, options)
        .then(res => {
          let paramList = []

          for (let key in res.data.params) {
            let parameter = []
            parameter['key'] = key
            parameter['value'] = res.data.params[key]

            paramList.push(parameter)
          }

          this.deviceParameterList = paramList
          this.fullDeviceParameterList = paramList

          if (this.deviceParameterList.length > 0) {
            let param = this.deviceParameterList.find(element => element.key === this.matlabParameterName.name)
            if (param !== undefined) {
              this.matlabParameterValue = JSON.stringify(param.value).replace('"', '')
            } else {
              this.matlabParameterValue = ''
            }
          } else {
            this.matlabParameterValue = ''
          }
        })
        .catch(function (err) {
          let msg = 'The list can not be refreshed. Please check and try again :: '
          msg += err.message
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },

    myRowClickHandler (record) {
      this.filterParameterNameList = ''
      this.changeFilterParameterNameList()

      this.matlabParameterValue = JSON.stringify(record.value).replace('[', '').replace(']', '').replace('"', '')

      let param = this.matlabParameterList.find(element => element.parameter_name === record.key)

      this.matlabParameterName.name = record.key
      this.matlabParameterName.type = param.parameter_type
      this.matlabParameterName.min = param.min
      this.matlabParameterName.max = param.max
      this.matlabParameterName.default = param.default
    },

    updateDevice () {
      // this.validateInput()

      let options = {
        leakbot_id: this.leakbotId,
        parameter_name: this.matlabParameterName.name
      }

      if (this.matlabParameterName.type === 'number') {
        options.value = this.matlabParameterValue
      } else {
        options.value = '[' + this.matlabParameterValue + ']'
      }

      this.$store.dispatch(APIEvent.MATLAB_DEVICE_UPDATE, options)
        .then(res => {
          if (res.data.ack === 'ack') {
            let parameter = []
            parameter['key'] = this.matlabParameterName.name
            if (this.matlabParameterName.type === 'number') {
              parameter['value'] = parseFloat(this.matlabParameterValue)
            } else {
              parameter['value'] = '[' + this.matlabParameterValue + ']'
            }

            let idx = this.deviceParameterList.findIndex((element) => element.key === this.matlabParameterName.name)

            if (idx >= 0) {
              this.deviceParameterList.splice(idx, 1)
            }

            this.deviceParameterList.unshift(parameter)
          }
        })
        .catch(function (err) {
          let msg = 'The list can not be refreshed. Please check and try again :: '
          msg += err.message
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },

    filterName () {
      if (this.filterParameterName === '') {
        this.deviceParameterList = this.fullDeviceParameterList
      } else {
        this.deviceParameterList = this.fullDeviceParameterList.filter(el => el.key.startsWith(this.filterParameterName))
      }
    },

    matlabParameterChange () {
      if (this.deviceParameterList.length > 0) {
        let param = this.deviceParameterList.find(element => element.key === this.matlabParameterName.name)
        if (param !== undefined) {
          this.matlabParameterValue = JSON.stringify(param.value).replace('"', '')
        } else {
          this.matlabParameterValue = ''
        }
      } else {
        this.matlabParameterValue = ''
      }
    },

    changeFilterParameterNameList () {
      this.matlabParameterList = this.fullMatlabParameterList.filter(el => el.parameter_name.startsWith(this.filterParameterNameList))
    }

  }
}
